<div class="confirmDialogWrap">
  <button
    class="close"
    mat-button
    mat-dialog-close
    type="button"
    [disabled]="mortgageCreationInProgress"
    (click)="proceedCancelAction()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <h3 mat-dialog-title>{{ data.title }}</h3>
    <div mat-dialog-content>{{ data.message }}</div>
    <div>
      <form #addMortgageForm="ngForm" [formGroup]="createMortgageForm" (ngSubmit)="saveMortgage()">
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input
              class="text-left"
              matInput
              placeholder="Principal"
              currencyMask
              formControlName="principal"
              autocomplete="off"
            />
            <span matPrefix>$ &nbsp;</span>
            <mat-error
              *ngIf="
                createMortgageFormValidation.principal.errors && createMortgageFormValidation.principal.errors.required
              "
              class="invalid-feedback"
              >Principal amount is required
            </mat-error>
            <mat-error
              *ngIf="createMortgageFormValidation.principal.errors && createMortgageFormValidation.principal.errors.min"
              class="invalid-feedback"
              >Enter a valid amount more then 100
            </mat-error>
            <mat-error
              *ngIf="createMortgageForm.get('principal')?.hasError('principalTooHigh')"
              class="invalid-feedback"
              >Pricipal value must not exceed property purchase price
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input matInput type="number" placeholder="Interest Rate" formControlName="interest" autocomplete="off" />
            <span matSuffix>%</span>
            <mat-error
              *ngIf="
                createMortgageFormValidation.interest.errors && createMortgageFormValidation.interest.errors.required
              "
              class="invalid-feedback"
              >Interest rate is required
            </mat-error>
            <mat-error
              *ngIf="
                createMortgageFormValidation.interest.errors &&
                (createMortgageFormValidation.interest.errors.min || createMortgageFormValidation.interest.errors.max)
              "
              class="invalid-feedback"
              >Enter a rate between 1 to 20
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input matInput type="number" placeholder="Term" formControlName="term" autocomplete="off" />
            <span matSuffix>Years</span>
            <mat-error
              *ngIf="createMortgageFormValidation.term.errors && createMortgageFormValidation.term.errors.required"
              class="invalid-feedback"
              >Term is required
            </mat-error>
            <mat-error
              *ngIf="
                createMortgageFormValidation.term.errors &&
                (createMortgageFormValidation.term.errors.min || createMortgageFormValidation.term.errors.max)
              "
              class="invalid-feedback"
              >Enter a term between 1 to 49
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input
              matInput
              [matDatepicker]="picker"
              [max]="today"
              placeholder="Mortgage Start Date"
              formControlName="startDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error
              *ngIf="
                createMortgageFormValidation.startDate.errors && createMortgageFormValidation.startDate.errors.required
              "
              class="invalid-feedback"
              >Mortgage started date is required
            </mat-error>
          </mat-form-field>
        </div>

        <div mat-dialog-actions class="mb-0">
          <div class="w-100 text-right">
            <!-- <button mat-button mat-dialog-close type="button" [disabled]="mortgageCreationInProgress"
              (click)="proceedCancelAction()">Cancel</button> -->
            <button
              class="ml-2"
              mat-flat-button
              color="primary"
              type="submit"
              [pmx-progress-button]="mortgageCreationInProgress"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
